module.exports = __webpack_public_path__ + "img/home-icon-12.0b23d1c8.png";